/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/indent */
import React from 'react';
import { Container } from '@pwskills/rachnaui';
import HeroContainer from '@/components/common/CourseDescriptionPage/HeroContainer';

const HeroSection = () => {
  return (
    <section id="overview" data-title="Overview" className="">
      <div
        className="w-full z-[1] relative"
        style={{
          background: 'linear-gradient(0deg, #FFF7F5 43.43%, #FFF 100%)',
        }}
      >
        <div
          className="absolute w-[400px] h-[400px] -top-[10%] -left-[20%] medium:!w-[500px] medium:!h-[500px] medium:!-left-[20%] medium:!-top-[25%] large:!-left-[15%] large:!-top-[30%] z-10 blur-[219px] opacity-80"
          style={{ background: 'rgba(233, 120, 98, 0.30)', borderRadius: '225px' }}
        />
        <Container className="py-8 large:!py-14 flex flex-col gap-[24px] medium:gap-14 !px-4  medium:!px-8 large:!px-20">
          <HeroContainer isArmature />
          {/* <HeroMetaData keyValueMetaInfo={keyValueMetaInfo} /> */}
        </Container>
      </div>
    </section>
  );
};

export default HeroSection;
